var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"frame-header"}),_c('div',{staticClass:"frame-footer"},[_c('el-button',{staticClass:"hbt",attrs:{"disabled":_vm.state,"icon":"el-icon-back","type":"text"},on:{"click":_vm.goBack}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }